<template>

<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg789"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs793"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath827"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path825" /></clipPath></defs><g
     id="g795"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g797"
       transform="translate(296.2344,196.3384)"><path
         d="M 0,0 7.135,-147.988"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path799" /></g><g
       id="g801"
       transform="translate(335.9531,196.3384)"><path
         d="M 0,0 2.379,-147.988"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path803" /></g><g
       id="g805"
       transform="translate(375.6719,196.3384)"><path
         d="M 0,0 -2.378,-147.988"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path807" /></g><g
       id="g809"
       transform="translate(415.3916,196.3384)"><path
         d="M 0,0 -7.135,-147.988"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path811" /></g><g
       id="g813"
       transform="translate(67.2813,437.1255)"><path
         d="M 0,0 H 151.126"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path815" /></g><g
       id="g817"
       transform="translate(67.2813,387.75)"><path
         d="M 0,0 H 151.126"
         style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
         id="path819" /></g><g
       id="g821"><g
         id="g823"
         clip-path="url(#clipPath827)"><g
           id="g829"
           transform="translate(409.7549,387.75)"><path
             d="m 0,0 h -96.747 c -11.047,0 -20.003,8.956 -20.003,20.002 v 96.748"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path831" /></g><g
           id="g833"
           transform="translate(409.7549,330.5)"><path
             d="M 0,0 V 57.25 L -116.75,174 H -364.5 c -14.62,0 -26.473,-11.853 -26.473,-26.473 v -444.054 c 0,-14.62 11.853,-26.473 26.473,-26.473 h 193.745"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path835" /></g><g
           id="g837"
           transform="translate(268.4727,227.0024)"><path
             d="m 0,0 h -30.816 c -10.631,0 -19.249,8.618 -19.249,19.249 0,10.63 8.618,19.248 19.249,19.248 h 236.313 c 10.631,0 19.248,-8.618 19.248,-19.248 C 224.745,8.618 216.128,0 205.497,0 H 34.896"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path839" /></g><g
           id="g841"
           transform="translate(426.793,265.499)"><path
             d="m 0,0 c -0.491,17.153 -14.551,30.907 -31.822,30.907 h -78.316 c -17.272,0 -31.331,-13.754 -31.823,-30.907"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path843" /></g><g
           id="g845"
           transform="translate(248.4639,227.0024)"><path
             d="m 0,0 11.502,-190.618 c 0.972,-16.11 14.32,-28.677 30.459,-28.677 h 130.775 c 16.14,0 29.489,12.567 30.46,28.677 L 214.698,0"
             style="stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path847" /></g></g></g></g></svg>
</template>
